export let basePath = 'http://localhost:8080/api';
export const apiVersion = 'v1';

if (process.env.NODE_ENV === 'production') {
  basePath = 'https://test-ampina-dot-bs-proyecto1.rj.r.appspot.com/api';
} else {
  console.log('Desarrollo..');
}
